<template>
<v-container id="dashboard" fluid tag="section">
    <h1></h1>
</v-container>
</template>

<script>

export default {
    name: "DashboardDashboard",
   
    data() {
        return {
         
        };
    },

    computed: {
        
      
    },
    mounted() {

    },
    async created() {

       
    },
    methods: {


    }
};
</script>

<style scoped>
.footer-hide>>>.VuePagination {
    display: none;
}
</style>
